import { put, call, takeEvery } from 'typed-redux-saga';
import { toast } from 'react-toastify';
import { PayloadAction } from '@reduxjs/toolkit';
import dayjs from 'dayjs';

import SettingGateway from '~apis/setting';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';
import { TUpdateGlobalAndProductSettingsReduxParams } from '~types/feat/setting';

import { ErrorMessages, SuccessMessages } from '~utils/constants';

export default function* watchUpdateSettings(api: SettingGateway): SagaWatcherReturnType {
    yield takeEvery('setting/settingUpdateSettingsAttempt', handleUpdateSettings, api);
}

function* handleUpdateSettings(api: SettingGateway, data: PayloadAction<TUpdateGlobalAndProductSettingsReduxParams>) {
    const state = store.getState();

    const authToken = state.auth.userDetails.authToken;

    const response = yield* call([api, api.updateSettings], { authToken, ...data.payload });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.settingUpdateSettingsFailure(response.message || ErrorMessages.GenericError));
        toast.error(response.message || ErrorMessages.GenericError);
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.settingUpdateSettingsSuccess());
        yield put(combinedActions.settingSetGlobalSettingsIsEditing(false));
        yield put(combinedActions.settingSetProductSettingDetailsModalIsOpen(false));
        yield put(combinedActions.settingSetProductSettingDetailsModalIsEditing(false));
        // delete/deactivate product
        yield put(combinedActions.settingSetProductSettingDeleteProductModalIsOpen(false));

        toast.success(SuccessMessages.SettingUpdateSettingsSuccess);
    }
}
